import React from 'react';
import { T } from '../../lib/tokens';
import { Wordmark } from '../ui/Wordmark';

interface Props {
  showWordmark?: boolean;
  title?: string;
  onBack?: () => void;
  right?: React.ReactNode;
}

export function MobileHeader({ showWordmark = false, title, onBack, right }: Props) {
  return (
    <div
      style={{
        padding: '8px 20px 12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: T.paper,
        gap: 12,
        minHeight: 44,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1, minWidth: 0 }}>
        {onBack && (
          <button
            onClick={onBack}
            style={{
              background: 'transparent',
              border: 0,
              padding: 8,
              margin: -8,
              cursor: 'pointer',
              color: T.graphite,
              WebkitTapHighlightColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <svg width={22} height={22} viewBox="0 0 22 22" fill="none">
              <path d="M14 4L6 11L14 18" stroke={T.graphite} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        )}
        {showWordmark ? (
          <Wordmark size={20} color={T.graphite} />
        ) : (
          title && <div style={{ fontSize: 17, fontWeight: 500, color: T.graphite }}>{title}</div>
        )}
      </div>
      {right && <div style={{ flexShrink: 0 }}>{right}</div>}
    </div>
  );
}
